module.exports = __webpack_public_path__ + "img/app-settings-active.cfd0e4e6.svg";